import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { RegisterComponent } from './register.component';
import { RegisterRoutingModule } from './register-routing.module';
import { MatTableModule, MatButtonModule, MatInputModule, MatFormFieldModule,MatIconModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { RecaptchaModule } from 'ng-recaptcha';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpVerificationComponent } from './otpverification/otpverification.component';
import { RouterModule, Routes } from '@angular/router';
import { TroubleLoginComponent } from '../troublelogin/troublelogin.component';

// const routes: Routes = [
//     {
//         path: '',
//         component: OtpVerificationComponent,
//         data: {
//             title: 'OTP Verification'
//         }
//     }
// ];
@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        MatchHeightModule,
        RegisterRoutingModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        SharedModule,
        MatButtonModule,
        ReactiveFormsModule,
        RecaptchaModule,
        NgOtpInputModule,
        // RouterModule.forChild(routes)
    ],
    declarations: [
        RegisterComponent,
    ],
    providers: [],
        exports: [RouterModule],
    
})
export class RegisterModule { }
